import React, { useState } from 'react';
import { Image, Modal, Upload } from 'antd';
import upload2 from "../../dist/webImages/filedocumet.png";
import { toast } from 'react-toastify';
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
const UploadProduct = ({filelis,updatess,removeatt,attremove  }) => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  const handleChange = ({ fileList: newFileList,file }) => {
    console.log(file)
    if (newFileList.length > 5) {
      newFileList = newFileList.slice(0, 5);
      toast.error("You cannot upload more than 5 files. Only the first 5 files will be uploaded.");
    }
    if(file.status === "removed") {
      // Existing files use their Product Attachment ID as uid. New uploads do
      // not have an attachment ID yet and should not be sent for removal.
      if (file.attachmentId != null) {
        removeatt([...attremove, file.attachmentId])
      }
    }
    updatess(newFileList);
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: 'none',
      }}
      type="button"
      className='w-full h-full'
    >
     <div className="pictureUpload__left">
     <img  src={upload2} alt="" /> 
     </div>
    </button>



  );
  return (
    <>
    <div className='puplo flex items-center gap-3'>
        <div>
      <Upload
        action="https://jsonplaceholder.typicode.com/posts"
        listType="picture-card"
        fileList={filelis}
        onPreview={handlePreview}
        onChange={handleChange}
        multiple={true}
      >
        {filelis.length >= 5 ? null : uploadButton}
      </Upload>
     
      </div>
      <div>
      <span className='font-medium'>Upload <br /> Product Images</span>
      <br />
      <small>At least 1 images must be uploaded</small>
      </div>
      </div>
      <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
        <img
          alt="example"
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
    </>
  );
};
export default UploadProduct;
